import { useList } from 'storfox-api-hooks'

import * as API from '~/constants/api'

export const useNotificationPopupList = () => {
  return useList(API.NOTIFICATION_LIST, {}, false)
}
